import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import {
  MyCafeteriSubaccountsTable,
  MyCafeteriaInfoLine,
  MyCafeteriaSignatureBlock,
  MyCafeteriaStatementTitle,
} from "my-cafeteria/components";
import { OcSidebarPartnerLogo } from "oc/components";

interface MyCafeteriaSzepApplicationCardPrintProps {
  applicationDate: string;
  employeeName: string;
  idNumber: string;
  contractCode: string;
  currentYear: number;
  hasPreviousBenefit: boolean;
  thisYear: number;
  data:
  | {
    _id: string;
    menuItem: { name: string };
    szepCardApplicationAmount: number;
  }[]
  | null;
}

export const MyCafeteriaSzepApplicationCardPrint: React.FC<
  MyCafeteriaSzepApplicationCardPrintProps
> = ({
  applicationDate,
  employeeName,
  idNumber,
  contractCode,
  currentYear,
  hasPreviousBenefit,
  thisYear,
  data,
}) => {
    const { t } = useTranslation();

    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <Box id="upper-component" paddingBottom="48px">
          <MyCafeteriaStatementTitle
            label={t("MY_CAFETERIA_SZEP_STATEMENT", { currentYear })}
            currentYear={currentYear}
          />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            paddingBottom="16px"
          >
            <Box id="data-block">
              <MyCafeteriaInfoLine
                label={t("OC_CALENDAR_DATE")}
                value={applicationDate}
              />
              <MyCafeteriaInfoLine
                label={t("OC_EMPLOYEE_NAME")}
                value={employeeName}
              />
              <MyCafeteriaInfoLine
                label={t("MY_CAFETERIA_TAX_ID_SIGN_ID")}
                value={idNumber}
              />
              <MyCafeteriaInfoLine
                label={t("MY_CAFETERIA_STATEMENT_CONTRACT_CODE")}
                value={contractCode}
              />
            </Box>
            <Box
              sx={{
                display: "none",
                displayPrint: "block",
                paddingRight: "85px",
              }}
            >
              <OcSidebarPartnerLogo />
            </Box>
          </Box>
          <Box padding="0px 56px">
            {hasPreviousBenefit ? (
              <Box>
                <Box paddingBottom="36px">
                  <Typography variant="body1">
                    {t("MY_CAFETERIA_SZEP_BENEFIT_NAME", { thisYear })}
                  </Typography>
                </Box>
                <Box width="400px" display="flex" flexDirection="column">
                  <Box display="flex" flexDirection="row">
                    <Box
                      flexGrow={1}
                      borderBottom="1px solid #5E6366"
                      paddingBottom="10px"
                    >
                      <Typography variant="body1">{t("MY_CAFETERIA_SUB_ACCOUNTS")}</Typography>
                    </Box>
                    <Box
                      width="85px"
                      textAlign="right"
                      borderBottom="1px solid #5E6366"
                      paddingBottom="10px"
                    >
                      <Typography variant="body1">{t("OC_AMOUNT")}</Typography>
                    </Box>
                  </Box>
                  {data?.map((item) => {
                    return (
                      <MyCafeteriSubaccountsTable
                        key={item?._id}
                        label={item?.menuItem?.name}
                        value={item?.szepCardApplicationAmount}
                      />
                    );
                  })}
                </Box>
              </Box>
            ) : (
              <Box>
                <Typography variant="body1">
                  {t("MY_CAFETERIA_I_HAVE_NO_BENEFIT", { thisYear })}
                </Typography>
              </Box>
            )}
            <Box height="36px" />
            <Typography variant="body1">{t("MY_CAFETERIA_SZEP_STAT_OF_RES")}</Typography>
          </Box>
        </Box>
        <MyCafeteriaSignatureBlock statement="szep" />
      </Box>
    );
  };

export default MyCafeteriaSzepApplicationCardPrint;
